import React , {Component} from "react";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

class HotelEmployeeAddModal extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            employeeName : '',
        };
    }

    handleChange = (e) => {
        this.setState({employeeName: e.target.value});
    };

    handleResultClick = (name) => {
        this.setState({employeeName: name});
    }

    render() {
        const {show, handleClose, language, add, apiError, errorMessage, loading} = this.props;
        const {employeeName} = this.state;
        return (
            <Modal show={show} onHide={handleClose}>
                <ModalHeader closeButton>
                    <ModalTitle>
                        <h4>{language.employeeDetails}<sup>*</sup></h4>
                    </ModalTitle>
                 </ModalHeader>
                <ModalBody>
                    <p>{language.pleaseProvideEmployeeName}</p>
                        <div className="row">
                            <div className="col-8 col-md-12">
                                <input id="employeeName" name="employeeName" type="text" placeholder="Enter the Heartist name" className="form-control" value={employeeName} onChange={this.handleChange} />
                            </div>
                        </div>

                        {apiError && errorMessage && (
                            <div className="error mt-2">
                                {errorMessage}
                            </div>
                        )}
                </ModalBody>
                <ModalFooter>
                    <button onClick={handleClose} className="btn btn-secondary" disabled={loading ? true : false}>Cancel</button>
                    <button 
                        onClick = {() => add(this.state.employeeName)} 
                        type    = "button" id="btnModalSubmit" 
                        className = "btn btn-primary"
                        disabled  = {loading ? true : false}> 
                        {language.employeeAdd}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default (HotelEmployeeAddModal);